// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { NotificationInboxPage } from '@/notification/components/notification-inbox-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/notifications/')({
  component: NotificationInboxRoute,
});

function NotificationInboxRoute() {
  return <NotificationInboxPage />;
}
